export default "__VITE_ASSET__BR6sm8n2__"